import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";
import { GetTransactionModel } from "@factory/model/query-model-transaction";
import { transactionFormDefault } from "./form.default";
import { TransactionFormSchema } from "./form.rule";

export const useFormDefaultTransaction = () => {
  const { formatDate } = useDateTimeContext();

  const getDefault = (cachedValue: GetTransactionModel | undefined) => {
    return !cachedValue
      ? transactionFormDefault
     : ({
        service: cachedValue.service,
        addon: cachedValue.addon,
        isPaid: Boolean(cachedValue.is_paid),
      } as TransactionFormSchema);
  };

  return {
    getDefault,
  };
};
